import React from 'react';

const About = () => {
  return (
    <div className="py-20 px-4 max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">Sobre VELNO</h1>
        <p className="text-xl text-gray-600 mb-8">
          En VELNO, creemos que la moda debe ser una extensión de tu personalidad. Nuestras camisetas y Hoodies están diseñadas para ofrecer la máxima comodidad y un estilo inigualable, perfectas para cualquier ocasión.
        </p>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Utilizamos solo algodón de la más alta calidad, asegurando una caída perfecta y una durabilidad excepcional. Cada pieza es una declaración de elegancia sin esfuerzo, pensada para quienes valoran la calidad y el diseño.
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 gap-12 mt-16">
        <div className="bg-gray-50 p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-4">Calidad Premium</h3>
          <p className="text-gray-600">Nuestras prendas están hechas con materiales de primera línea para garantizar comodidad y durabilidad en cada uso.</p>
        </div>
        <div className="bg-gray-50 p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-4">Diseño Único</h3>
          <p className="text-gray-600">Cada diseño refleja nuestra pasión por crear piezas que combinen estilo moderno con funcionalidad diaria.</p>
        </div>
      </div>
    </div>
  );
};

export default About;